@if (payments) {
<ul class="m-t-1 m-t-4-s p-r-4-l center">
    <ng-container *ngFor="let payment of payments last as isLast">
        @if (payment.icon) {
        <li class="inline-block"
            [ngClass]="{'m-r-3 m-r-2-s': !isLast}">
            <img [dfImage]="payment.icon"
                 [attr.alt]="payment.name"
                 [height]="24"
                 [width]="36">
        </li>
        }
    </ng-container>
</ul>
}
